'use strict';

/*jshint camelcase: false */

angular.module('risevision.rva.controllers')
  .value('EDITOR_PATH', '/editor')
  .value('DISPLAYS_PATH', '/displays')
  .value('SCHEDULES_PATH', '/schedules')
  .controller('AppCtrl', ['$scope', '$rootScope', '$window', '$location', 
    '$state', '$loading', 'userState', 'storeProductsFactory', 'environment', 
    'EDITOR_PATH', 'DISPLAYS_PATH', 'SCHEDULES_PATH',
    function ($scope, $rootScope, $window, $location, $state, $loading, userState, 
      storeProductsFactory, environment, EDITOR_PATH, DISPLAYS_PATH, SCHEDULES_PATH) {
      var navOptions = [{
        title: 'Start',
        link: $state.href('rva.start'),
        cid: true,
        states: ['rva.start']
      }, {
        title: 'Presentations',
        link: environment.APPS_URL + EDITOR_PATH,
        cid: true,
        states: [
          'rva.editor.manage'
        ]
      }, {
        title: 'Gadgets',
        link: $state.href('rva.gadgets.list'),
        cid: true,
        states: [
          'rva.gadgets.list',
          'rva.gadgets.manage'
        ]
      }, {
        title: 'Displays',
        link: environment.APPS_URL + DISPLAYS_PATH,
        cid: true
      }, {
        title: 'Schedules',
        link: environment.APPS_URL + SCHEDULES_PATH,
        cid: true
      }];
      
      $scope.navOptions = [];
      $scope.navSelected = 'rva.start';
      
      $scope.hideCommonHeader = false;

      $loading.startGlobal('risevision.user.authenticate');

      $rootScope.$on('$stateChangeSuccess', function () {
        $scope.navSelected = $state.current.name;

        if ($state.current.name.indexOf('common.auth') !== -1) {
          if ($state.current.name === 'common.auth.unauthorized') {
            $scope.hideCommonHeader = true;
          } else {
            $window.location.href = environment.APPS_URL + $state.href($state.current.name, $state.current.params);
          }
        } else if ($state.current.name === 'rva.start' || $state.current.name === 'rva.editor.list') {
          $window.location.href = environment.APPS_URL + $state.href($state.current.name, $state.current.params);
        }
      });
      
      $rootScope.$on('risevision.user.signedOut', function () {
        $window.rva__accessingUser = '';
        $window.rva__reportUserLoggedOut();
        
        $scope.navOptions = [];

        $state.go('common.auth.unauthorized');
      });

      $rootScope.$on('risevision.user.authorized', function () {
        var userRoles = userState.getCopyOfProfile().roles;
        var companyId = userState.getUserCompanyId();

        $window.rva__accessingUser = userState.getUsername();
        $window.rva__reportUserLoggedIn(userRoles, companyId);

        updateNavOptions();
      });

      var updateNavOptions = function() {
        var visibleOptions = [];
        for (var i = 0; i < navOptions.length; i++) {
          if (navOptions[i].title === 'Presentations' && (userState.hasRole('ce') || userState.hasRole('cp'))) {
            visibleOptions.push(navOptions[i]);
          }
          else if ((navOptions[i].title === 'Gadgets' || navOptions[i].title === 'Schedules') && userState.hasRole('cp')) {
            visibleOptions.push(navOptions[i]);
          }
          else if (navOptions[i].title === 'Displays' && userState.hasRole('da')) {
            visibleOptions.push(navOptions[i]);
          }
          else if (navOptions[i].title === 'Start') {
          	visibleOptions.push(navOptions[i]);
          }
        }
        
        $scope.navOptions = visibleOptions;
      };

      // RVA calls this:
      $window.rvChCtrl = {
        trackPageview: function(contentId) {
      	  // [AD] Disabling pageviews from RVA
      	  //analyticsFactory.pageview(contentId);
      	},
        openStoreContentModal: function() {
          storeProductsFactory.open()
            .then(function(productCode) {
              $window.rva__onStoreContentModalClose({
                pc: productCode
              });
            })
            .catch(function() {
              $window.rva__onStoreContentModalClose({});
            });
        }
      };
      
    }
  ]); //ctr
